import { AUTH_LOGIN } from "../utils/constant";
import { createRequest } from "../utils/network";

export async function login(token: string) {
  const res = await createRequest<any>(AUTH_LOGIN, { method: "GET" }, token);

  return res;
}
